module.exports = __webpack_public_path__ + "static/image/main/m/banner-4-1.ver2_0_2.jpg?9c50f7f4";